import { FilterMatchMode } from 'primereact/api';

export const filters = {
  oid: { value: null, matchMode: FilterMatchMode.CONTAINS },
  numeroSeleccion: { value: null, matchMode: FilterMatchMode.CONTAINS },
  observaciones: { value: null, matchMode: FilterMatchMode.CONTAINS },
  totalAmount: { value: null, matchMode: FilterMatchMode.CONTAINS },
  estadoParseado: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
